import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { ApiError, authApi } from '../api';
import { finalizeTokens } from '../session-helpers';

export function AcceptInvitePage() {
  const navigate = useNavigate();
  const { token } = useParams<{ token: string }>();
  const [fullName, setFullName] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!token) return;
    setSubmitting(true);
    setError(null);
    try {
      const tokens = await authApi.acceptInvite(
        token,
        fullName || undefined,
        password || undefined,
      );
      await finalizeTokens(tokens);
      navigate('/command-center', { replace: true });
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Could not accept invitation');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="grid min-h-screen place-items-center px-4">
      <div className="card w-full max-w-sm">
        <h1 className="text-xl font-semibold">Join workspace</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          Set up (or sign in to) your Fleet Iris account to accept this invitation.
        </p>
        <form className="mt-6 space-y-4" onSubmit={submit}>
          <div>
            <label className="block text-sm font-medium">
              Your full name <span className="text-muted-foreground">(new accounts only)</span>
            </label>
            <input
              type="text"
              className="input mt-1"
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
            />
          </div>
          <div>
            <label className="block text-sm font-medium">Password</label>
            <input
              type="password"
              minLength={8}
              required
              className="input mt-1"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          {error && (
            <p className="rounded bg-danger/10 px-3 py-2 text-xs text-danger" role="alert">
              {error}
            </p>
          )}
          <button type="submit" disabled={submitting} className="btn-primary w-full">
            {submitting ? 'Joining…' : 'Join workspace'}
          </button>
        </form>
      </div>
    </div>
  );
}
